import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        width: "100%",
        padding: { xs: 2, md: 4 },
      }}
    >
      <Typography
        component="h1"
        variant="h3"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: { xs: "200%", md: "250%" },
          margin: { xs: "2%", md: "2% 0" },
          
        }}
      >
        Early Warning Signals
      </Typography>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pb: { xs: 8, sm: 12 },
        }}
      >
        <Box
            sx={{
              textAlign: { xs: "center", md: "right" }, // Align text to right for larger screens
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginRight: { xs: 0, md: "20px" }, // Adjust margin for spacing
              
            }}
          >
            <Typography
              component="p"
              sx={{
                fontSize: { xs: "100%", md: "140%" },
                fontFamily: "sans-serif",
                marginTop: { xs: "2%", md: 0 }, // Adjust margin-top for spacing
                marginBottom: { xs: "2%", md: "5%" },
                lineHeight: 1.5,
                letterSpacing: 0.2,
                textAlign: { xs: "center", md: "center" }, // Align text to right for larger screens
              }}
            >
              Make your investments BulletProof. Directly get easy to read and analysis signals from 60,000+ Companies, Firms, Trusts to take correct decisions on the Current or Future Investments!!
            </Typography>
          </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: { xs: "column", md: "row-reverse" }, // Reverse the order for larger screens
            alignItems: { xs: "center", md: "flex-start" },
            justifyContent: { xs: "center", md: "space-between" },
            mb: { xs: 4, md: 6 }, // Add margin-bottom for spacing
          }}
        >
          <img
            src={require("../img/3.png")}
            alt="Description of the image"
            style={{ width: "100%", height: "auto", maxWidth: "500px" }}
          />
          <Box
            sx={{
              textAlign: { xs: "center", md: "center" }, // Align text to right for larger screens
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: { xs: "2%", md: 15 },
              marginRight: { xs: 0, md: "20px" }, // Adjust margin for spacing
            }}
          >
            <Typography
              component="h2"
              variant="h4"
              sx={{
                textAlign: { xs: "center", md: "center" }, // Align text to right for larger screens
              }}
            >
              Get to know Before&nbsp;
              <Typography
                component="span"
                variant="h4"
                sx={{
                  color: "primary.main",
                }}
              >
                time
              </Typography>
            </Typography>
            <Typography
              component="p"
              sx={{
                fontSize: { xs: "100%", md: "140%" },
                fontFamily: "sans-serif",
                marginTop: { xs: "2%", md: 5 }, // Adjust margin-top for spacing
                marginBottom: { xs: "2%", md: "5%" },
                lineHeight: 1.5,
                letterSpacing: 0.2,
                textAlign: { xs: "center", md: "center" }, // Align text to right for larger screens
              }}
            >
             Make your investments BulletProof. Directly get easy to read and analysis signals from 60,000+ Companies, Firms, Trusts to take correct decisions on the Current or Future Investments!!
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
